import { render } from "./OrderGrid.vue?vue&type=template&id=1bd6da82"
import script from "./OrderGrid.vue?vue&type=script&lang=js"
export * from "./OrderGrid.vue?vue&type=script&lang=js"

import "./OrderGrid.vue?vue&type=style&index=0&id=1bd6da82&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__